"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = buildImageUrl;
function buildImageUrl(rawUrl, params) {
    const url = new URL(rawUrl.trim());
    url.search = "";
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    return url.toString();
}
